import React, { useEffect, useState } from "react";

import { fetchSinglePost } from "../../api";
import PostTemplate from "./templates/PostTemplate";

function SingleHistory({ id }) {
	const [post, setPost] = useState();

	useEffect(() => {
		async function getPost() {
			const data = await fetchSinglePost(id, "historie");
			if (data) {
				setPost(data);
			}
		}
		getPost();
	}, [id]);
	return (
		<PostTemplate
			title={post?.title?.rendered}
			author={post?._embedded?.author[0]?.name}
			image={post?.fimg_url}
			content={post?.content?.rendered}
			date={post?.date}
		/>
	);
}
export default SingleHistory;
